module.exports = __webpack_public_path__ + "img/PT3020.23b93484.svg";